import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { VirtualBundleSales: { getVirtualBundleSales } } = apiUrls;

export const VIRTUAL_BUNDLE_SALES_SUCCESS = 'VIRTUAL_BUNDLE_SALES_SUCCESS';
export const VIRTUAL_BUNDLE_SALES_LOADING = 'VIRTUAL_BUNDLE_SALES_LOADING';

export const getVirtualBundleSalesData = ({ fromdate, todate }) => async (dispatch) => {
    try {
        const { url } = getVirtualBundleSales
        const requestData = {
            ...getVirtualBundleSales,
            url: url.replace('{{fromdate}}', fromdate).replace('{{todate}}', todate)
        };
        const data = await REQUEST(requestData);
        dispatch({
            type: VIRTUAL_BUNDLE_SALES_SUCCESS,
            data,
        })

    } catch (e) {

        dispatch({
            type: VIRTUAL_BUNDLE_SALES_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            }
        })
    }

}

export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: VIRTUAL_BUNDLE_SALES_LOADING,
        isLoading
    });
}